import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  StudentLifeArticleCard,
  StudentWellbeingArticle,
} from '../interfaces/strapi';
import { ApiService } from './api.service';
import { GenericApiResponse } from '../interfaces/api';

@Injectable({
  providedIn: 'root',
})
export class ArticleService {
  constructor(
    private readonly http: HttpClient,
    private readonly api: ApiService
  ) {}

  public filteredArticles: StudentLifeArticleCard[] = [];

  public activeArticleFilter: number | null = null;

  /**
   * Function to determine whether the subtitle is shorter than the title
   * in order to change styling accordingly
   * @param article
   * @returns boolean
   */
  public hasShorterSubtitle(
    article: StudentLifeArticleCard | StudentWellbeingArticle
  ): boolean {
    // Buffer value is required as sometimes the subtitle can be slightly longer than
    // the title but still requires the same styling as if it were shorter
    const adjustmentBufferVal = 5;
    return (
      !!article.subtitle &&
      article.subtitle.length < article.title.length + adjustmentBufferVal
    );
  }

  public getAverageRatings(articleIds: string[]): Observable<Object> {
    const endpoint = `${this.api.url}/articles/average-rating`;

    return this.http.get(endpoint, { params: { 'articleIds[]': articleIds } });
  }

  public hasUserRatedArticle(
    articleId: string
  ): Observable<GenericApiResponse<boolean>> {
    const endpoint = `${this.api.url}/articles/${articleId}/has-rated`;

    const headers = new HttpHeaders()
      .set('Cache-Control', 'no-cache, no-store, must-revalidate')
      .set('Pragma', 'no-cache')
      .set('Expires', '0');

    return <Observable<GenericApiResponse<boolean>>>(
      this.http.get(endpoint, { headers })
    );
  }

  public rateArticle(
    articleId: string,
    rating: number
  ): Observable<GenericApiResponse<string>> {
    const endpoint = `${this.api.url}/articles/${articleId}/rate`;

    return <Observable<GenericApiResponse<string>>>(
      this.http.post(endpoint, { rating })
    );
  }
}
